module.exports = __webpack_public_path__ + "shanz/static/media/aboutS.767892dc.png";